export default [
    {
        path: '/partner-categories',
        name: 'pagePartnerCategoriesList',
        meta: { title: 'partnerCategories.listTitle', roles: ['ADMIN', 'TEAM_LEADER'] },
        component: () => import('@/pages/partner-categories'),
    },
    {
        path: '/partner-categories/:id/edit',
        name: 'pagePartnerCategoriesEdit',
        meta: { title: 'partnerCategories.editFormTitle', roles: ['ADMIN', 'TEAM_LEADER'] },
        component: () => import('@/pages/partner-categories/id/edit'),
    },
]
